import React from 'react';

export type IconType = 'arrow-up' | 'arrow-down';

interface IconProps {
  type: IconType;
  size?: number;
  color?: string;
}

const DEFAULT_SIZE = 20;
const DEFAULT_COLOR = '#FCFCFD';

const paths: Record<IconType, string> = {
  'arrow-up': 'M12 19V5M12 5L5 12M12 5L19 12',
  'arrow-down': 'M12 5V19M12 19L19 12M12 19L5 12',
};

export const Icon: React.FC<IconProps> = ({ type, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} viewBox='0 0 24 24' fill='none'>
    <path d={paths[type]} stroke={color} strokeWidth='1.67' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);
